<template>
  <div>
    <p class="cm-mg-p-wzd">1.1 {{ $t('common_words.calendar_info') }}</p>
    <hr />
    <div class="row">
      <div class="col-md-6">
        <fg-input
          type="text"
          :label="`${$t('common_words.name')}: *`"
          v-model="model.name"
          name="common_words.name"
          v-validate="modelValidations.name"
          :error="getError('common_words.name', true)"
          :placeholder="`${$t('common_words.calendar_name')}...`"
        ></fg-input>
      </div>
    </div>
  </div>
</template>
<script>
import store from '@/store';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinForm from 'src/mixins/forms/mixin-form';

export default {
  data() {
    return {
      model: {
        name: null,
        calendar_type: '1',
      },
      modelValidations: {
        name: {
          required: true,
        },
      },
    };
  },
  mixins: [MixinForm, MixinPermissions],
  methods: {
    validate() {
      return this.$validator
        .validateAll()
        .then((res) => {
          this.$emit('on-validated', res, this.model);

          this.$emit('fillCalendarForm', 'firstStep');
          return res;
        })
        .then((resp) => {
          if (!resp) return resp;

          return store.dispatch(
            'utils/validationInputsRequired',
            '-first-step'
          );
        });
    },
  },

  mounted() {
    let editForm = {};
    if (this.isUpdate() && sessionStorage.getItem('editForm')) {
      editForm = JSON.parse(sessionStorage.getItem('editForm'));
      this.model.name = editForm.name;
      this.model.calendar_type = editForm.calendar_type;
    }
  },
};
</script>
<style></style>
